import type { UnwrapNestedRefs } from "vue";
import Qs from "qs";
import request from "../../utils/request";
import cloneDeep from "lodash-es/cloneDeep";
import merge from "lodash-es/merge";
import isFunction from "lodash-es/isFunction";
import { buildProps } from "../../utils/props";
import type { PaginationProps } from "element-plus";
import type { Method } from "axios";
import { onMounted, onBeforeMount, reactive, ref, watch, isReactive, isRef, toRefs, nextTick } from "vue";
import type { ExtractPropTypes, PropType, Ref, SetupContext } from "vue";
import { toRaw } from "vue";
import { FetchDataTypeConf, FetchListTypeConf, FetchTypeConf } from "./types";
import type { AfterSuccessFuncType, AfterErrorFuncType, BeforeFetchDataFilterType, FetchDataConfType, FetchDataFilterType, FetchDataTypeConfKeyType, FilterSetDataFuncType, FetchListTypeConfKeyType, FetchTypeConfKeyType, LoadDataOperateType, IsSuccessType, MergeDataFilterType, MergeResponeDataType, OnLoadDataSuccessType, ResDataFilterType, UrlFunctionType, FetchApiInterface, HandleCurrentChangeInterface, HandleSizeChangeInterface, LoadDataStateType } from "./types";
import { isEqual } from "lodash-es";
/*
  loadDataMix * 常用的查询详情的接口封装；
*/

// loadDataMix 组件props定义
export const loadDataProps = buildProps({
  // 初始化立即获取数据
  createImmediatelyLoad: {
    type: Boolean,
    default: true,
  },
  /**
   * 配置请求实例,promise fetch对象
   */
  fetchApi: {
    type: [Boolean, Function as PropType<FetchApiInterface>],
    default: false,
  },
  /**
   * 配置查询的url
   */
  url: {
    type: [String, Function as PropType<UrlFunctionType>],
    default: "",
  },

  /**
   * 配置查询的方式
   */
  fetchType: {
    type: String as PropType<Method>,
    values: Object.keys(FetchTypeConf).map(
      (key) => FetchTypeConf[key as FetchTypeConfKeyType]
    ),
    default: FetchTypeConf.GET,
  },

  /**
   * 配置查询带的数据
   */
  fetchData: {
    type: [Object, Array, String],
    default: () => ({}),
  },
  /**
   * 配置查询的前置数据过滤方法
   */
  beforeFetchDataFilter: {
    type: Function as PropType<BeforeFetchDataFilterType>,
    default: (res: any): unknown => {
      const { currentPage, pageSize, ...otherData } = res;
      return {
        ...otherData,
        pageNum: currentPage,
        pageSize: pageSize,
      };
    },
  },
  /**
   * 通过请求的数据过滤是否发起请求方法
   */
  disabledFetchFilter: {
    type: Function,

    default: <T>(res: T): boolean => {
      return false;
    },
  },

  /**
   * 配置查询的数据过滤方法
   */
  fetchDataFilter: {
    type: Function as PropType<FetchDataFilterType>,

    default: (res: unknown): unknown => res,
  },
  /**
   * 配置请求的数据的提交方式，可以为json或者form
   */
  fetchDataType: {
    type: String,
    values: Object.keys(FetchDataTypeConf).map(
      (key) => FetchDataTypeConf[key as FetchDataTypeConfKeyType]
    ),
    default: FetchDataTypeConf.JSON,
  },
  /**
   * 配置请求成功后的数据回调
   */
  onLoadDataSuccess: {
    type: Function as PropType<OnLoadDataSuccessType>,
    default: (res: unknown) => res,
  },
  /**
   * 配置请求成功后返回的数据是否是成功数据
   */
  isSuccess: {
    type: Function as PropType<IsSuccessType>,
    default: (res: any): boolean => !!res,
  },
  /**
   * 配置返回的数据过滤方法
   */
  resDataFilter: {
    type: Function as PropType<ResDataFilterType>,
    default: (res: any): any => res,
  },
  /**
   * 配置默认返回数据
   */
  data: {
    type: Array as PropType<Array<any>>,
    default: (): Array<any> => [],
  },
  /**
   * 是否展示列表翻页
   */
  pagination: {
    type: Boolean,
    default: true,
  },
  /**
   *  列表翻页的配置
   */
  pageProps: {
    type: Object as PropType<PaginationProps>,
    default: (): any => ({}),
  },
  notCloneData: {
    type: Boolean,
    default: false,
  },
});

type LoadDataPropsType = ExtractPropTypes<typeof loadDataProps>;

export default function (
  props: LoadDataPropsType,
  ctx: SetupContext<unknown>,
  config: {
    afterSuccessFunc: AfterSuccessFuncType;
    filterSetData?: FilterSetDataFuncType;

    afterErrorFunc: AfterErrorFuncType;
  }
): LoadDataOperateType {
  let timer: any;

  const loadDataState: LoadDataStateType = reactive({
    loading: false,
    listData: props.notCloneData ? props.data : cloneDeep(props.data),
    stateFetchData: {},
    pageSize: props.pageProps?.pageSize || 50,
    total: props.data.length,
    currentPage: 1,
  });

  // const loading: Ref<boolean> = ref(false);
  // let listData: UnwrapNestedRefs<unknown> = reactive(cloneDeep(props.data));
  // const stateFetchData: UnwrapNestedRefs<unknown> = reactive({});
  // const pageSize: Ref<number> = ref(props.pageProps?.pageSize || 10);
  // const total: Ref<number> = ref(props.data.length);
  // const currentPage = ref(1);

  let lastFetchData: unknown = {}; // 上一次请求参数
  onBeforeMount(() => {
    if (props.createImmediatelyLoad) {
      loadData();
    }
  });
  watch(
    () => props.fetchData,
    (newValue: any, oldValue: any) => {
      newValue;
    }
  );
  watch(
    () => props.data,
    (newValue: Array<any>, oldValue: Array<any>) => {
      loadDataState.listData = props.notCloneData ? props.data : cloneDeep(newValue);
    }
  );
  // methods start
  /**
   * 延时加载判断，预防请求过于频繁
   * @param  {Boolean} reload 是否重新加载
   */
  function lazyLoad(reload: boolean) {
    loadDataState.loading = true;
    // clearTimeout(timer);
    // document.getElementsByClassName("el-main")[0].focus();
    //  timer = setTimeout(() => {
    const el: any = document.getElementsByClassName("el-scrollbar")[0];
    if (el) el.focus();
    nextTick(() => {
      loadData(reload);
    });
    //}, 500);
  }
  /**
     * 拷贝一个全新数据的方法
  
     */
  function getJson(d: any): any {
    let setData = d;
    if (isReactive(setData)) {
      setData = toRaw(setData);
    } else if (isRef(setData)) {
      setData = toRaw(setData.value);
    }
    return cloneDeep(setData);
  }

  function lightLoadData(resetFirstPage = false){
    return loadData(resetFirstPage,true)
  }
  /**
   * 请求数据的方法
   * @param  {Boolean} resetFirstPage 重新请求数据
   */
  async function loadData(resetFirstPage = false,hiddenLoading?:boolean|null) {
    console.log("loading.....");

    if (!props.url && !props.fetchApi) {
      loadDataState.loading = false;
      return;
    }
    if (resetFirstPage) {
      loadDataState.currentPage = 1;
    }

    let fetchDataAll = {
      ...getJson(props.fetchData),
      currentPage: loadDataState.currentPage,
      pageSize: loadDataState.pageSize,
      ...getJson(loadDataState.stateFetchData),
    };

    fetchDataAll = props.beforeFetchDataFilter(fetchDataAll);
    const setUrl = isFunction(props.url) ? props.url(fetchDataAll) : props.url;
    fetchDataAll = props.fetchDataFilter(fetchDataAll);

    if (
      props.fetchType == FetchTypeConf.GET &&
      typeof props.fetchApi != "function"
    ) {
      fetchDataAll = {
        params: fetchDataAll,
      };
    }
    const disabledFetch = props.disabledFetchFilter(fetchDataAll);
    if (disabledFetch) {
      return;
    }
    let setConf = {};
    if (props.fetchDataType == FetchDataTypeConf.FORM) {
      setConf = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        transformRequest: [
          function (data: unknown) {
            data = Qs.stringify(data);
            return data;
          },
        ],
      };
    }
    if(!hiddenLoading)  loadDataState.loading = true;
    lastFetchData = fetchDataAll;
    const fetchApi: Promise<any> =
      typeof props.fetchApi == "function"
        ? props.fetchApi(fetchDataAll, setConf)
        : request({
            url: setUrl,
            method: props.fetchType as Method,
            [props.fetchType == FetchTypeConf.GET ? "params" : "data"]:
              fetchDataAll,
            ...setConf,
          });
    return fetchApi
      .then((res) => {
        loadDataState.loading = false;
        res = props.resDataFilter && props.resDataFilter(res);

        if (props.isSuccess(res)) {
          resetData(res.list, res.total);
          if (props.onLoadDataSuccess) props.onLoadDataSuccess(res);
        }
        if (config.afterSuccessFunc) {
          config.afterSuccessFunc(res);
        }
      })
      .catch((err) => {
        console.log(err);
        loadDataState.loading = false;
        if (config.afterErrorFunc) {
          config.afterErrorFunc(err);
        }
        resetData();
        throw err;
      });
  }
  /**
   * 重新设置列表状态的方法
   * @param  {Array} data 设置的列表数据
   * @param  {Number} total 共计多少条数据
   */
  function resetData(data: Array<any> = [], setTotal = 0) {
    loadDataState.loading = false;
    if (typeof config.filterSetData == "function") {
      loadDataState.listData = config.filterSetData(data);
    } else {
      loadDataState.listData = data;
    }

    loadDataState.total =
      typeof setTotal == "string" ? Number(setTotal) : setTotal;
  }

  /**
   * 选中分页的改变并重新请求
   * @param  {Number} currentPage 切换的分页
   */
  const handleCurrentChange: HandleCurrentChangeInterface = (
    setCurrentPage: number
  ) => {
    loadDataState.currentPage = setCurrentPage;
    loadData();
  };
  /**
   * 选中分页的大小并重新请求
   * @param  {Number} size 分页的大小
   */
  const handleSizeChange: HandleSizeChangeInterface = (size: number) => {
    loadDataState.currentPage = 1;
    loadDataState.pageSize = size;
    loadData();
  };
  return {
    loadDataState,
    lastFetchData,
    lazyLoad,
    lightLoadData,
    loadData,
    handleCurrentChange,
    handleSizeChange,
  };
}
